
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referimiento-hipotecario-remax-bpd",
      function () {
        return require("private-next-pages/referimiento-hipotecario-remax-bpd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referimiento-hipotecario-remax-bpd"])
      });
    }
  